import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../../Landlord/styles/Landlord.css'
import { useNavigation } from 'react-router-dom';
import Sidebar from '../Layouts/Sidebar';
import Topbar from '../Layouts/Topbar';

const AdminProperties = () => {
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const base_url = 'https://api.homehive.co.zw/api';
  const navigate = useNavigate()

  const propertyTypes = [
    { type: 'apartment', icon: 'building', label: 'Apartments' },
    { type: 'full_house', icon: 'home', label: 'Full Houses' },
    { type: 'room', icon: 'door-open', label: 'Rooms' },
    { type: 'lodge', icon: 'hotel', label: 'Lodges' },
    { type: 'boarding_house', icon: 'building-user', label: 'Boarding Houses' }
  ];

  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${base_url}/properties/`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      console.log(response)
      setProperties(response.data.results);
      // Artificially delay setting isLoading to false to ensure the loader is visible
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      console.error('Error fetching properties:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to load properties',
        icon: 'error',
        confirmButtonColor: '#1a237e'
      });
      setIsLoading(false);
    }
  };

  const getPropertyTypeIcon = (type) => {
    const propertyType = propertyTypes.find(p => p.type === type);
    return propertyType ? propertyType.icon : 'home';
  };

  const handleViewProperty = (property) => {
    setSelectedProperty(property);
    setCurrentImageIndex(0);
    setShowModal(true);
    document.body.classList.add('modal-open');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProperty(null);
    setCurrentImageIndex(0);
    document.body.classList.remove('modal-open');
  };

  const handleNextImage = () => {
    if (selectedProperty?.images) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === selectedProperty.images.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const handlePrevImage = () => {
    if (selectedProperty?.images) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? selectedProperty.images.length - 1 : prevIndex - 1
      );
    }
  };

  const filteredProperties = filter === 'all'
    ? properties
    : properties.filter(prop => prop.property_type === filter);

  // Force loader to display for testing
  if (isLoading) {
    return (
      <div className="admin-analytics">
        <Sidebar/>
        <Topbar/>
        <div className="analytics-content">
        <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999
      }}>
        <div className="propagate-loader" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          margin: '40px 0',
          zIndex: '700'
        }}>
          <div className="propagate-ball" style={{
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            backgroundColor: '#1a237e',
            animation: 'propagate 1.5s ease-in-out infinite',
            transform: 'scale(0)'
          }}></div>
          <div className="propagate-ball" style={{
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            backgroundColor: '#1a237e',
            animation: 'propagate 1.5s ease-in-out infinite',
            transform: 'scale(0)',
            animationDelay: '0.15s'
          }}></div>
          <div className="propagate-ball" style={{
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            backgroundColor: '#1a237e',
            animation: 'propagate 1.5s ease-in-out infinite',
            transform: 'scale(0)',
            animationDelay: '0.3s'
          }}></div>
          <div className="propagate-ball" style={{
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            backgroundColor: '#1a237e',
            animation: 'propagate 1.5s ease-in-out infinite',
            transform: 'scale(0)',
            animationDelay: '0.45s'
          }}></div>
          <div className="propagate-ball" style={{
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            backgroundColor: '#1a237e',
            animation: 'propagate 1.5s ease-in-out infinite',
            transform: 'scale(0)',
            animationDelay: '0.6s'
          }}></div>
        </div>
        <p style={{
          marginTop: '20px',
          color: '#1a237e',
          fontSize: '16px',
          fontWeight: '500'
        }}>Loading your properties...</p>
        <style>{`
          @keyframes propagate {
            0%, 100% { transform: scale(0); }
            50% { transform: scale(1); }
          }
        `}</style>
      </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-analytics">
      <Sidebar/>
    <Topbar/>
    
      <div style={{marginTop: '-18px'}} className="analytics-content">
        <div className="properties-container">
          <div className="properties-header">
            <div className="filter-section">
              <button
                className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                <i className="fas fa-th-large"></i>
                All
              </button>
              {propertyTypes.map(({ type, icon, label }) => (
                <button
                  key={type}
                  className={`filter-btn ${filter === type ? 'active' : ''}`}
                  onClick={() => setFilter(type)}
                >
                  <i className={`fas fa-${icon}`}></i>
                  {label}
                </button>
              ))}
            </div>
          </div>

          {filteredProperties.length === 0 ? (
            <div className="no-properties">
              <i className="fas fa-home"></i>
              <h2>No Properties Found</h2>
              <p>Start by adding your first property</p>
              <Link to="/landlord/add-property" className="add-property-btn">
                Add Property
              </Link>
            </div>
          ) : (
            <div className="properties-grid">
              {filteredProperties.map(property => (
                <div key={property.id} className="property-card">
                  <div className="property-img">
                    {property.images && property.images[0] ? (
                      <img src={base_url + property.images[0].image} alt={property.description} />
                    ) : (
                      <div className="no-image">
                        <i className="fas fa-image"></i>
                        <span>No Image</span>
                      </div>
                    )}
                    <div className="property-type-badge">
                      {property.property_type_display}
                    </div>
                    {property.availability_status === 'available' ? (
                      <div className="status-badge available">
                        Available
                      </div>
                    ) : (
                      <div className="status-badge unavailable">
                        Occupied
                      </div>
                    )}
                  </div>

                  <div className="property-details">
                    <div className="property-loc">
                      {property.location} &nbsp;&nbsp;  ${property?.monthly_rental || property?.price_per_night}/{property.property_type === 'lodge' ? 'night' : 'month'}
                    </div>

                  </div>

                  <div className="property-actions">
                    <button onClick={() => navigate(`/admin/property/${property.id}`)} className="view-btn">
                      <i className="fas fa-eye"></i>
                      View
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default AdminProperties;